import { useContext, useEffect, useMemo, useState } from "react";
import styled from "styled-components";
import Breadcrumbs from "../based/Breadcrumbs";
import Common from "../based/Common";
import { INITPAGING, NOTIFY, PLATFORM, PLATFORM_NAME, STATUS_TRANSACTION, STATUS_TRANSACTION_NAME } from "../based/Constants";
import InvoiceServices from "../based/services/InvoiceServices";
import ConfirmReleaseModal from "./ConfirmReleaseModal";
import InvoiceManagementDetailModal from "./InvoiceManagementDetailModal";
import InvoiceManagementEditModal from "./InvoiceManagementEditModal";
import { InvoiceManagementContext } from "./InvoiceManagementProvider";
import InvoiceReasonModal, { InvoiceReasonModify } from "./InvoiceReasonModal";
import { Notify } from "../based/Notify";
import UploadInvoiceModal from "./UploadInvoiceModal";
import TableFooter from "../based/content/TableFooter";
import TFUSelect from "../based/inputs/TFUSelect";
import TFUDatetime from "../based/inputs/TFUDatetime";
import Lazada from "./assets/Lazada.png";
import Shopee from "./assets/Shopee.png";
import Tiktok from "./assets/Tiktok.png";

//tất cả/cần phát hành/cần điều chỉnh/quá hạn/đã phát hành
const TAB_SCREEN = [
    { label: "Tất cả", value: -1 },
    { label: "Cần phát hành/Cần điều chỉnh/Quá hạn", value: 0 },
    { label: "Đã phát hành", value: 1 },
];

const PLATFORM_TAB_OPTIONS = [
    { value: 0, label: "Tất cả sàn" },
    { value: PLATFORM.Internal, label: PLATFORM_NAME.Internal },
    { value: PLATFORM.Lazada, label: PLATFORM_NAME.Lazada },
    { value: PLATFORM.Shopee, label: PLATFORM_NAME.Shopee },
    { value: PLATFORM.Tiktok, label: PLATFORM_NAME.Tiktok },
];

const ORDER_STATUS_OPTIONS = [
    {
        value: 0,
        label: "Tất cả trạng thái",
    },
    {
        value: STATUS_TRANSACTION.UNPAID_FROM_CUSTOMER, //đang xử lý
        label: STATUS_TRANSACTION_NAME.UNPAID_FROM_CUSTOMER,
    },
    {
        value: STATUS_TRANSACTION.PROCESSING, //đang xử lý
        label: STATUS_TRANSACTION_NAME.PROCESSING,
    },
    {
        value: STATUS_TRANSACTION.PRODUCTION, //đang sản xuất
        label: STATUS_TRANSACTION_NAME.PRODUCTION,
    },
    {
        value: STATUS_TRANSACTION.PACKING, //đang đóng gói
        label: STATUS_TRANSACTION_NAME.PACKING,
    },
    {
        value: STATUS_TRANSACTION.READYTOSHIP, //sẵn sàng giao
        label: STATUS_TRANSACTION_NAME.READYTOSHIP,
    },
    {
        value: STATUS_TRANSACTION.SHIPPING, //đang vận chuyển
        label: STATUS_TRANSACTION_NAME.SHIPPING,
    },
    {
        value: STATUS_TRANSACTION.FAIL_DELIVERY_TO_CUSTOMER, //giao thất bại
        label: STATUS_TRANSACTION_NAME.FAIL_DELIVERY_TO_CUSTOMER,
    },
    {
        value: STATUS_TRANSACTION.RETURNED_TO_SENDER, //hoàn trả về cho người gửi
        label: STATUS_TRANSACTION_NAME.RETURNED_TO_SENDER,
    },
    {
        value: STATUS_TRANSACTION.CANCELED, //hủy
        label: STATUS_TRANSACTION_NAME.CANCELED,
    },
    {
        value: STATUS_TRANSACTION.SUCCEED, //giao thành công
        label: STATUS_TRANSACTION_NAME.SUCCEED,
    },
    {
        value: STATUS_TRANSACTION.ERRORED, //lỗi
        label: STATUS_TRANSACTION_NAME.ERRORED,
    },
];

function InvoiceManagementOverview(props) {
    const [paging, setPaging] = useState({ ...INITPAGING, pageSize: 50, invoiceStatus: -1, fromDate: new Date(new Date().setMonth(new Date().getMonth() - 12)), toDate: new Date(new Date().setDate(new Date().getDate() + 1)) });
    const [datas, setDatas] = useState([]);
    const {
        reasonId,
        setReasonId,
        showDetail,
        setShowDetail,
        showConfirmRelease,
        setShowConfirmRelease,
        showEditInvoice,
        setShowEditInvoice,
        showReasonModal,
        setShowReasonModal,
        showUploadInvoice,
        setShowUploadInvoice,
        originalInvoiceId,
        setOriginalInvoiceId,
    } = useContext(InvoiceManagementContext);

    useEffect(() => {
        var toDate = new Date(new Date().setDate(new Date().getDate() + 1));
        var fromDate = new Date(new Date().setMonth(new Date().getMonth() - 12));
        getDatas({ ...paging, fromDate: fromDate, toDate: toDate, platform: 0, orderStatus: 0 });
    }, []);

    useEffect(() => {
        if (showConfirmRelease === false) {
            var toDate = new Date(new Date().setDate(new Date().getDate() + 1));
            var fromDate = new Date(new Date().setMonth(new Date().getMonth() - 12));
            getDatas({ ...paging, fromDate: fromDate, toDate: toDate, platform: 0, orderStatus: 0 });
        }
    }, [showConfirmRelease]);

    const getDatas = async (paging) => {
        const [err, data] = await InvoiceServices.GetInvoiceOrderModelsAsync(paging);
        if (!err && data) {
            setDatas(data.listObjects);
            setPaging(data.paging);
        } else {
            setDatas([]);
            setPaging(paging);
        }
    };

    const exportFile = async (invoiceId) => {
        const [err, data] = await InvoiceServices.ExportInvoiceFile(invoiceId);
        if (!err && data) {
            window.open(data);
        } else {
            Notify(NOTIFY.ERROR, NOTIFY.ERROR, "Xuất file hóa đơn thất bại");
        }
    };

    const syncFile = async (invoiceId) => {
        const [err, data] = await InvoiceServices.SyncFileByTransactionUUID(invoiceId);
        if (!err && data) {
            Notify(NOTIFY.SUCCESS, NOTIFY.SUCCESS, "Đồng bộ file hóa đơn nháp thành công");
            window.open(data);
            getDatas(paging);
        } else {
            Notify(NOTIFY.ERROR, NOTIFY.ERROR, "Đồng bộ file hóa đơn nháp thất bại");
        }
    };

    const _renderTab = useMemo(() => (
        <ul className="nav nav-tabs tabs-bordered">
            {TAB_SCREEN.map((item, index) => {
                return (
                    <li key={index} className="nav-item">
                        <a
                            className={paging.invoiceStatus == item.value ? "nav-link active" : "nav-link btn-light"}
                            onClick={() => {
                                getDatas({ ...paging, pageNumber: 1, invoiceStatus: item.value });
                            }}
                        >
                            <span>{item.label}</span>
                        </a>
                    </li>
                );
            })}
        </ul>
    ));

    const renderPlatformIcon = (platform) => {
        switch (platform) {
            case PLATFORM.Lazada:
                return <img src={Lazada} alt="" />;
            case PLATFORM.Shopee:
                return <img src={Shopee} alt="" />;
            case PLATFORM.Tiktok:
                return <img src={Tiktok} alt="" />;
            default:
                return "";
        }
    };

    const checkInvoiceModified = async (originalInvoiceId) => {
        const [err, data] = await InvoiceServices.CheckInvoiceModified(originalInvoiceId);
        if (!err && data) {
            return data;
        } else {
            return 0;
        }
    };

    return (
        <>
            <Wrapper>
                <Breadcrumbs currentPage="Quản lý hóa đơn (Đầu ra)" />
                {_renderTab}
                <div className="filter_box">
                    <div className="filter_box-search">
                        <input
                            type="text"
                            placeholder="Tìm kiếm mã đơn, người nhận, SĐT,..."
                            value={paging.keyword}
                            onChange={(e) => {
                                let val = e.target.value;
                                setPaging({ ...paging, keyword: val });
                            }}
                            onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                    getDatas({ ...paging, pageNumber: 1 });
                                }
                            }}
                        />
                        <div
                            className="search-button cursor-pointer"
                            onClick={(e) => {
                                getDatas({ ...paging, pageNumber: 1 });
                            }}
                        >
                            <div className="icon">
                                <svg width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <circle cx="7.84532" cy="7.84532" r="7.09532" stroke="white" stroke-width="1.5" />
                                    <path d="M12.7482 13.2383L16.1805 16.6706" stroke="white" stroke-width="1.5" stroke-linecap="round" />
                                </svg>
                            </div>
                        </div>
                    </div>
                    <div className="box_selection ml-auto">
                        <TFUSelect
                            placeholder="Lọc trạng thái đơn hàng"
                            options={ORDER_STATUS_OPTIONS}
                            value={paging.orderStatus}
                            name="order-status"
                            onChanged={(value) => {
                                getDatas({ ...paging, orderStatus: +value, pageNumber: 1 });
                            }}
                        />
                    </div>
                    <div className="box_selection">
                        <TFUSelect
                            placeholder="Lọc sàn thương mại"
                            options={PLATFORM_TAB_OPTIONS}
                            value={paging.platform}
                            name="platform"
                            onChanged={(value) => {
                                getDatas({ ...paging, platform: +value, pageNumber: 1 });
                            }}
                        />
                    </div>
                    <div className="box_selection date-picker">
                        <div className="from-date">
                            <TFUDatetime
                                maxDate={new Date(paging.toDate)}
                                value={new Date(paging.fromDate)}
                                onChanged={(date, name) => {
                                    getDatas({
                                        ...paging,
                                        fromDate: date,
                                        pageNumber: 1,
                                    });
                                }}
                                name="from-date"
                                className="form-control from-date"
                                showDateOnly
                            />
                        </div>
                        <div className="to-date">
                            <TFUDatetime
                                minDate={new Date(paging.fromDate)}
                                value={new Date(paging.toDate)}
                                onChanged={(date, name) => {
                                    getDatas({
                                        ...paging,
                                        toDate: date,
                                        pageNumber: 1,
                                    });
                                }}
                                name="to-date"
                                className="form-control to-date"
                                showDateOnly
                            />
                        </div>
                    </div>
                </div>
                <section className="table-refund">
                    <table className="table table-bordered">
                        <thead>
                            <tr>
                                <th scope="col">Ngày đặt</th>
                                <th scope="col">Đơn hàng</th>
                                <th scope="col">Thông tin hóa đơn</th>
                                <th scope="col">Số tiền</th>
                                <th scope="col">Trạng thái đơn</th>
                                <th scope="col">Trạng thái HĐ</th>
                                <th scope="col"></th>
                            </tr>
                        </thead>
                        <tbody>
                            {datas && datas.length > 0 ? (
                                datas.map((item, index) => {
                                    return (
                                        <tr key={index}>
                                            <td className="vertical-align-middle">
                                                <div className="order-date">
                                                    <span>{Common.formatDate(new Date(item.createdDate))}</span>
                                                </div>
                                            </td>
                                            <td className="vertical-align-middle">
                                                <div className="order-detail">
                                                    <p className="order-id">
                                                        {item.id}
                                                        <div
                                                            className="icon"
                                                            onClick={(e) => {
                                                                window.open(`/order-detail/${item.id}`);
                                                            }}
                                                        >
                                                            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <path
                                                                    d="M13.5 9.75V14.25C13.5 14.6478 13.342 15.0294 13.0607 15.3107C12.7794 15.592 12.3978 15.75 12 15.75H3.75C3.35218 15.75 2.97064 15.592 2.68934 15.3107C2.40804 15.0294 2.25 14.6478 2.25 14.25V6C2.25 5.60218 2.40804 5.22064 2.68934 4.93934C2.97064 4.65804 3.35218 4.5 3.75 4.5H8.25"
                                                                    stroke="#13AAFF"
                                                                    stroke-width="2"
                                                                    stroke-linecap="round"
                                                                    stroke-linejoin="round"
                                                                />
                                                                <path d="M11.25 2.25H15.75V6.75" stroke="#13AAFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                                                <path d="M7.5 10.5L15.75 2.25" stroke="#13AAFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                                            </svg>
                                                        </div>

                                                        <div className="float_right">
                                                            <div className="icon">{renderPlatformIcon(item.platform)}</div>
                                                        </div>
                                                    </p>
                                                    <p className="order-number">Mã đơn hàng: {item.orderNumber}</p>
                                                    <p className="order-customer-number">{item.userName}</p>
                                                    <p className="order-phone-number">{item.phoneNumber}</p>
                                                </div>
                                            </td>
                                            <td
                                                className="vertical-align-middle"
                                                style={{
                                                    maxWidth: "650px",
                                                }}
                                            >
                                                {item.taxCode != null && item.taxCode != "" ? (
                                                    <div className="invoice-address-detail">
                                                        <div className="detail-line">
                                                            <div className="left-detail">
                                                                <span>Cty</span>
                                                            </div>
                                                            <div className="right-detail">
                                                                <span>{item.companyName}</span>
                                                            </div>
                                                        </div>
                                                        <div className="detail-line">
                                                            <div className="left-detail">
                                                                <span>Mst</span>
                                                            </div>
                                                            <div className="right-detail">
                                                                <span>{item.taxCode}</span>
                                                            </div>
                                                        </div>
                                                        <div className="detail-line">
                                                            <div className="left-detail">
                                                                <span>Đc</span>
                                                            </div>
                                                            <div className="right-detail">
                                                                <span>{item.address}</span>
                                                            </div>
                                                        </div>
                                                        <div className="detail-line">
                                                            <div className="left-detail">
                                                                <span>Email</span>
                                                            </div>
                                                            <div className="right-detail">
                                                                <span>{item.email}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <div className="upper-case">KHÁCH KHÔNG LẤY HÓA ĐƠN</div>
                                                )}
                                            </td>
                                            <td className="vertical-align-middle">
                                                <div className="invoice-money">
                                                    <div className="detail-line">
                                                        <div className="left-detail">
                                                            <span>Tổng trước thuế</span>
                                                        </div>
                                                        <div className="right-detail">
                                                            <span>{Common.formatCurrency(item.totalAmountWithoutTax)}</span>
                                                        </div>
                                                    </div>
                                                    <div className="detail-line">
                                                        <div className="left-detail">
                                                            <span>Tổng thuế 8%</span>
                                                        </div>
                                                        <div className="right-detail">
                                                            <span>{Common.formatCurrency(item.taxAmount)}</span>
                                                        </div>
                                                    </div>
                                                    <div className="detail-line">
                                                        <div className="left-detail">
                                                            <span>Tổng tiền sau thuế</span>
                                                        </div>
                                                        <div className="right-detail">
                                                            <span>{Common.formatCurrency(item.totalAmount)}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </td>
                                            <td className="vertical-align-middle">
                                                <div className="order-status">
                                                    <p>{item.orderStatusName}</p>
                                                    <p>{item.orderModifiedDate && Common.formatDate(new Date(item.orderModifiedDate))}</p>
                                                </div>
                                            </td>
                                            <td className="vertical-align-middle">
                                                {item.invoiceOrderStatus != "" ? (
                                                    <div className="text-danger">{item.invoiceOrderStatus}</div>
                                                ) : (
                                                    item.invoiceInfoHistories &&
                                                    item.invoiceInfoHistories.length > 0 &&
                                                    item.invoiceInfoHistories.map((invoiceInfo, idx) => {
                                                        return (
                                                            <div
                                                                className="invoice-status"
                                                                key={idx}
                                                                onClick={(e) => {
                                                                    exportFile(invoiceInfo.id);
                                                                }}
                                                            >
                                                                <div className="invoice-status-line">
                                                                    <div className="icon">
                                                                        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                            <path
                                                                                d="M15.75 11.25V14.25C15.75 14.6478 15.592 15.0294 15.3107 15.3107C15.0294 15.592 14.6478 15.75 14.25 15.75H3.75C3.35218 15.75 2.97064 15.592 2.68934 15.3107C2.40804 15.0294 2.25 14.6478 2.25 14.25V11.25"
                                                                                stroke="#28B259"
                                                                                stroke-width="1.5"
                                                                                stroke-linecap="round"
                                                                                stroke-linejoin="round"
                                                                            />
                                                                            <path d="M5.25 7.5L9 11.25L12.75 7.5" stroke="#28B259" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                                            <path d="M9 11.25V2.25" stroke="#28B259" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                                        </svg>
                                                                    </div>
                                                                    <span>
                                                                        {invoiceInfo.adjustmentTypeName} ({invoiceInfo.invoiceNo}) - {Common.formatDate(new Date(invoiceInfo.createdDate))}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        );
                                                    })
                                                )}
                                            </td>
                                            <td
                                                className="vertical-align-middle"
                                                style={{
                                                    maxWidth: "200px",
                                                }}
                                            >
                                                <div className="lst-button">
                                                    <button
                                                        className="btn btn-custom"
                                                        onClick={(e) => {
                                                            setShowDetail(true);
                                                            setOriginalInvoiceId(item.originalInvoiceId);
                                                        }}
                                                    >
                                                        Chi tiết
                                                    </button>
                                                    {item.invoiceStatus == 1 && (
                                                        <button
                                                            className="btn btn-custom"
                                                            onClick={(e) => {
                                                                //kiểm tra đã có hóa đơn điều chỉnh chưa

                                                                checkInvoiceModified(item.originalInvoiceId).then((adjustInvoiceNo) => {
                                                                    if (adjustInvoiceNo > 0) {
                                                                        setShowEditInvoice(true);
                                                                        setOriginalInvoiceId(adjustInvoiceNo);
                                                                    } else {
                                                                        setShowReasonModal(true);
                                                                        setOriginalInvoiceId(item.originalInvoiceId);
                                                                    }
                                                                });
                                                            }}
                                                        >
                                                            Điều chỉnh/Thay thế
                                                        </button>
                                                    )}
                                                    {item.invoiceStatus != 1 && (
                                                        <button
                                                            className="btn btn-custom"
                                                            onClick={(e) => {
                                                                setShowUploadInvoice(true);
                                                                setOriginalInvoiceId(item.originalInvoiceId);
                                                            }}
                                                        >
                                                            Upload HĐ
                                                        </button>
                                                    )}
                                                    {item.transactionUUID != null && item.transactionUUID != "" && item.invoiceStatus != 1 && (
                                                        <button
                                                            className="btn btn-custom overflow-hidden"
                                                            onClick={(e) => {
                                                                syncFile(item.originalInvoiceId);
                                                            }}
                                                        >
                                                            Đồng bộ hóa đơn nháp (Bằng TransactionUUID)
                                                        </button>
                                                    )}
                                                </div>
                                            </td>
                                        </tr>
                                    );
                                })
                            ) : (
                                <div>Không có dữ liệu</div>
                            )}
                        </tbody>
                    </table>
                    <TableFooter itemToDisplay={paging.pageSize} paging={paging} onFilter={(paging) => getDatas(paging)} />
                </section>
            </Wrapper>
            <InvoiceManagementDetailModal
                show={showDetail}
                onClose={() => {
                    setShowDetail(false);
                    setOriginalInvoiceId(null);
                }}
                originalInvoiceId={originalInvoiceId}
                onSucceed={() => {
                    getDatas(paging);
                }}
            />
            <ConfirmReleaseModal
                show={showConfirmRelease}
                onClose={() => setShowConfirmRelease(false)}
                originalInvoiceId={originalInvoiceId}
                onSucceed={() => {
                    getDatas(paging);
                }}
            />
            <InvoiceManagementEditModal
                show={showEditInvoice}
                onClose={() => {
                    setShowEditInvoice(false);
                    setReasonId(InvoiceReasonModify.Undefined);
                }}
                originalInvoiceId={originalInvoiceId}
                onSuceed={() => {
                    setShowEditInvoice(false);
                    setShowDetail(true);
                    setReasonId(InvoiceReasonModify.Undefined);
                }}
                reasonId={reasonId}
            />
            <UploadInvoiceModal
                show={showUploadInvoice}
                onClose={() => setShowUploadInvoice(false)}
                originalInvoiceId={originalInvoiceId}
                onSucceed={() => {
                    setShowUploadInvoice(false);
                    getDatas(paging);
                }}
            />
            <InvoiceReasonModal
                show={showReasonModal}
                onClose={() => {
                    setShowReasonModal(false);
                    setReasonId(InvoiceReasonModify.Undefined);
                }}
                originalInvoiceId={originalInvoiceId}
                onContinue={() => {
                    setShowReasonModal(false);
                    setShowEditInvoice(true);
                }}
            />
        </>
    );
}

export default InvoiceManagementOverview;

const Wrapper = styled.div`
    .filter_box {
        margin: 10px 0;
    }

    .float_right {
        margin-left: auto;
    }

    .filter_box {
        display: flex;
        align-items: center;
        gap: 14px;
    }

    .box_selection {
        display: flex;
        align-items: center;
    }

    .filter_box-search {
        display: flex;
        align-items: center;
    }

    .filter_box-search input[type="text"] {
        border: none;
        background: no-repeat;
        width: 100%;
        padding: 0 0 0 8px;
    }

    .filter_box-search {
        border: 1px solid #d9d9d9;
        background: #fff;
        width: 335px;
    }

    .filter_box-search .search-button {
        border: 1px solid #d9d9d9;
        background: #444;
        padding: 10px 25px;
        margin-left: auto;
    }

    .icon {
        display: flex;
    }

    .box_selection > div {
        width: 180px;
    }

    .box_selection.date-picker {
        gap: 10px;
    }

    tbody tr {
        background: white;
    }

    thead tr th {
        border: 1px solid #d9d9d9;
        background: #d9d9d9;
    }

    p.refund-money span {
        color: #444;
        text-align: center;
        font-family: Roboto;
        font-size: 20px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
    }

    .badge.badge-custom {
        border-radius: 30px;
        background: #28b259;
        color: #fff;
        font-family: Roboto;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px; /* 142.857% */
        margin: 4px;
    }

    .order-date span {
        color: #444;
        font-family: Roboto;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
        word-break: break-word;
    }

    .order-detail p {
        margin: 4px 0;
        color: #444;
        font-family: Roboto;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
        word-break: break-word;
    }

    p.order-id {
        display: flex;
        align-items: center;
        color: #13aaff;
        font-family: Roboto;
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
    }

    tbody .icon {
        display: flex;
    }

    p.order-id .icon {
        margin-left: 8px;
    }

    .detail-line {
        display: flex;
        align-items: center;
        margin: 4px 0;
    }

    .left-detail {
        width: 70px;
    }

    .right-detail {
        flex: 1;
    }

    .left-detail span {
        color: #444;
        font-family: Roboto;
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
        word-break: break-word;
    }

    .right-detail span {
        color: #444;
        font-family: Roboto;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
        word-break: break-word;
    }

    .invoice-money .detail-line .right-detail {
        margin-left: auto;
        flex: none;
    }

    .invoice-money .detail-line .left-detail {
        width: 120px !important;
    }

    .order-status p {
        color: #64c5b1;
        font-family: Roboto;
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        margin: 0;
    }

    .invoice-status {
        cursor: pointer;
    }

    .invoice-status-line {
        display: flex;
        align-items: center;
    }

    .invoice-status-line span {
        color: #28b259;
        font-family: Roboto;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
        word-break: break-word;
    }

    .invoice-status-line .icon {
        margin-right: 4px;
    }

    .lst-button {
        display: flex;
        flex-direction: column;
        gap: 10px;
    }
`;
